"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsNullOrUndef_1 = __importDefault(require("../../typeAssertions/valueIsNullOrUndef"));
const formatBorderWith = (style) => {
    if (style.borderStyle
        && (0, valueIsNullOrUndef_1.default)(style.borderTopWidth)
        && (0, valueIsNullOrUndef_1.default)(style.borderRightWidth)
        && (0, valueIsNullOrUndef_1.default)(style.borderBottomWidth)
        && (0, valueIsNullOrUndef_1.default)(style.borderLeftWidth)) {
        delete style.borderStyle; // eslint-disable-line
    }
};
exports.default = formatBorderWith;
